export enum SkinVersions {
    Ollehbet = "ollehbet",
    Betmidas = "betmidas",
    Xrpbet = "xrpbet",
    Oddsgate = "oddsgate",
    Betvivocomz = "betvivocomz",
    Lifebetflat = "lifebetflat",
    Bettorian = "bettorian",
}
